import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class DeliveryTimeWindowSelectFeature implements IFlagFeature {
  name = Features.DELIVERY_TIME_WINDOW_SELECT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
